<template>
    <select-c
        v-model="modelCategory"
        :options="categories"
        wrapper-class="xs:w-full mb-1 sm:mb-0 mr-0 sm:mr-1"
    />
    <select-c
        v-model="modelCommodity"
        :options="commodities"
        wrapper-class="xs:w-full mb-1 sm:mb-0 mr-0 sm:mr-1"
    />
    <select-c
        v-model="modelContract"
        :options="contracts"
        wrapper-class="xs:w-full mb-1 sm:mb-0 mr-0 sm:mr-1"
    />
</template>

<script setup>
import { ref, watch, watchEffect, computed, onMounted } from 'vue';

const props = defineProps({
    allContracts: {
        type: Object,
        required: true
    },
    initial: {
        type: Object,
        default: () => ({})
    },
    modelValue: {
        type: [String, Object],
        default: null, // You can set a default value if necessary
    },
});

const emit = defineEmits(['update:modelValue', 'category', 'commodity']);

const modelCategory = ref(props.modelValue?.category || '');
const modelCommodity = ref(props.modelValue?.commodity || '');
const modelContract = ref(props.modelValue?.contract || '');

const categories = computed(() => {
    return Object.keys(props.allContracts).map(key => ({ label: key, value: key, default: key === modelCategory.value }));
});

const commodities = computed(() => {
    const categoryContracts = props.allContracts[modelCategory.value];
    return categoryContracts ? Object.keys(categoryContracts).map(key => ({ label: key, value: key, default: key === modelCommodity.value })) : [];
});

const contracts = computed(() => {
    if (props.allContracts[modelCategory.value][modelCommodity.value]) {
        const hasNearest = props.allContracts[modelCategory.value][modelCommodity.value][0].isNearest !== undefined;

        const root = props.initial.contract ? props.initial.contract.substring(0, 2) : null;

        var allContracts = props.allContracts[modelCategory.value][modelCommodity.value].map((contract, index) => {
            let isDefault;

            if (hasNearest && (!root || !contract.symbol.startsWith(root))) {
                isDefault = contract.isNearest === 'Yes';
            } else if (modelContract.value) {
                isDefault = modelContract.value === contract.symbol;
            } else {
                isDefault = index === 0;
            }

            return {
                label: contract.contractMonthYear,
                value: contract.symbol,
                default: isDefault
            };
        });

        return allContracts;
    }

    return [];
});

watchEffect(() => {
    emit('update:modelValue', modelContract.value);
});

watch(() => props.initial, (newInitial) => {
    modelCategory.value = newInitial.category ?? categories.value[0]?.value;
    modelCommodity.value = newInitial.commodity ?? commodities.value[0]?.value;

    if (contracts && !newInitial.contract) {
        const defaultItem = contracts.value.find((mContract) => mContract.default);
        modelContract.value = defaultItem ? defaultItem.value : contracts.value[0].value;
    } else {
        modelContract.value = newInitial.contract ?? contracts.value[0]?.value;
    }
}, { immediate: true });

watch(modelCategory, (newCategory) => {
    if (newCategory) {
        modelCommodity.value = commodities.value[0]?.value ?? '';
    }
    emit('category', modelCategory.value);
});

watch(modelCommodity, (newCommodity) => {
    if (newCommodity) {
        const defaultItem = contracts.value.find((mContract) => mContract.default);
        modelContract.value = defaultItem ? defaultItem.value : contracts.value[0].value;
        // modelContract.value = contracts.value[0]?.value ?? '';
    }
    emit('commodity', modelCommodity.value);
});

onMounted(() => {
    if (modelContract.value) {
        emit('update:modelValue', modelContract.value);
    }

    emit('category', modelCategory.value);
    emit('commodity', modelCommodity.value);
});
</script>
